;(function (doc, win) {

    var docEl = doc.documentElement,
        recalc = function () {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            docEl.style.fontSize = 20 * (clientWidth / 1920) + 'px';
        };


    if (!doc.addEventListener) return;

    win.addEventListener('resize', recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
    recalc();
    // doc.addEventListener('onload', recalc, false);

})(document, window);